import styled from 'styled-components'

export default styled.article`
  height: 100%;
`
